// extracted by mini-css-extract-plugin
export default {"form":"Login_form__Oz3is","authBlock":"Login_authBlock__2xQ0L","authIcon":"Login_authIcon__AlBr8","oauthLogin":"Login_oauthLogin__zmwOc","logoutBlock":"Login_logoutBlock__nEjIJ"};